<template>
    <div>        
        <v-sheet class="px-6 pt-6">
            <div class="container">
                <div class="d-flex flex-wrap justify-space-between mb-8">
                    <h5 class="ma-3 mb-0 d-flex flex"> View Adpoint Details</h5>                        
                    <div class="flex-1 text-right">
                        <!-- BUTTONS HERE -->                        
                    </div>
                </div>
            </div>
        </v-sheet>
        <v-form  v-model="editFormValid" ref="editForm">
        <v-row justify="center">                 
            <v-col cols="10" md="4">
                <e-info-card                                    
                >
                    <template slot="basic-info-slot"> 
                        <h6>Primary Fields</h6>    
                        <div>
                            <v-list>
                                <v-list-item>
                                    <!-- <v-list-item-avatar>
                                        <img :src="''" alt="" />
                                    </v-list-item-avatar> -->                                                                                                                              
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Adpoint ID" 
                                            v-model="adpointid"
                                            outlined
                                            :readonly="true"     
                                            hide-details="true"
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item v-if="hasValue(description)">
                                    <!-- <v-list-item-avatar>
                                        <img :src="''" alt="" />
                                    </v-list-item-avatar> -->                                                                                                                              
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Title" 
                                            v-model="description"                                            
                                            :readonly="true"     
                                            hide-details="true"
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item v-if="hasValue(networkId)">                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-select                                                                     
                                            v-model="networkId"
                                            :items="networkOptions"                 
                                            label="Network"  
                                            :readonly="true"   
                                            hide-details="true"                                                                                                                                                                                                                                                          
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>  
                                <v-list-item v-if="hasValue(clusterId)">                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-select                                                                     
                                            v-model="clusterId"
                                            :items="clusterOptions"                 
                                            label="Cluster"  
                                            :readonly="true"                                                                                                                                                                            
                                                                                                   
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>
                                <v-list-item v-if="hasValue(deviceId)">                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-select                                                                     
                                            v-model="deviceId"
                                            :items="deviceTypeOptions"                 
                                            label="Placement Type"    
                                            :readonly="true"     
                                            hide-details="true"                                                                                                                                                                                                                                                    
                                        />
                                    </v-list-item-content>                                
                                </v-list-item> 
                                <!--<v-list-item>                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-select                                                                     
                                            v-model="brandId"
                                            :items="brandOptions"                 
                                            label="Brand"       
                                            :readonly="true"   
                                            hide-details="true"                                                                                                      
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>-->
                                <v-list-item v-if="hasValue(location)">                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-select                                                                     
                                            v-model="location"
                                            :items="locationOptions"                 
                                            label="Location"                                                                                                                                                    
                                            :readonly="true"      
                                            hide-details="true"              
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>  
                                <v-list-item v-if="hasValue(environment)">                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-select                                                                     
                                            v-model="environment"
                                            :items="environmentOptions"                 
                                            label="Environment"                                                                                                                                                    
                                            :readonly="true"    
                                            hide-details="true"               
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>     
                                <v-list-item v-if="debugmode">                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-checkbox
                                            v-model="debugmode"
                                            label="Debug Mode"      
                                            :readonly="true"    
                                            hide-details="true"
                                        />                                        
                                    </v-list-item-content>                                
                                </v-list-item>     
                                <v-list-item v-if="fieldSchemeHasChanged"> 
                                    <v-list-item-content>
                                        <v-alert border="top" color="red lighten-2" dark>
                                            When either a new <strong>Network</strong> or <strong>Placement Type</strong> is selected, you have to hit the 'Save' button before continuing, so that the correct Attribute Fields will be displayed, based on your selection.
                                        </v-alert>
                                    </v-list-item-content>                        
                                </v-list-item>
                            </v-list>  
                        </div>  
                        <h6 class="pt-6">Behaviour</h6>      
                        <div>
                            <v-list>
                                <v-list-item>                                                               
                                    <v-list-item-content class="pt-0">
                                        <v-select                                                                     
                                            v-model="manualstatus"
                                            :items="['Enabled','Disabled']"                 
                                            label="Availability"                                             
                                            :readonly="true"        
                                            hide-details="true"            
                                        />
                                    </v-list-item-content>                                
                                </v-list-item> 
                                <!-- <v-list-item>                                                             
                                    <v-list-item-content>
                                        <v-text-field 
                                            label="Default Daily Capacity Potential (Impressions)" 
                                            :rules="requiredRules"
                                            v-model.number="nominalCapacity"
                                            type="number"
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>           -->
                                <v-list-item v-if="hasValue(impression_factor)">                                                             
                                    <v-list-item-content class="pt-0">
                                        <v-text-field 
                                            label="No of Adpoints" 
                                            :readonly="true"  
                                            v-model.number="impression_factor"
                                            type="number"
                                            hide-details="true"
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>  
                                <v-list-item>                                                             
                                    <v-list-item-content>
                                        <v-checkbox
                                            label="Multiview"                                             
                                            v-model="multiview"      
                                            :readonly="true"                                      
                                        />
                                    </v-list-item-content>                                
                                </v-list-item>                    
                            </v-list>  
                        </div>     



                        <h6 class="pt-6" v-if="allLocations.find(l=>l.code == location)">Location & Operating Hours Information</h6>   
                        <div v-if="allLocations.find(l=>l.code == location)">
                            <v-list>
                                <v-list-item>
                                    <pre class="location-extra-pre">
{{ displayLocationExtraInfo }}
                                    </pre>                                    
                                </v-list-item>                                
                            </v-list>  
                        </div>     
                        
                        <h6 class="pt-6" v-if="filteredGenericAttrs.length > 0">General Attributes</h6>  
                        <div v-if="filteredGenericAttrs.length > 0">
                            <v-list>     
                                <v-list-item v-for="attr in filteredGenericAttrs" :key="attr.name">       
                                    <v-list-item-content class="pt-0">
                                        <AttributeEditField v-bind="attr" v-model="attr.value" :readonly="true" />                                                                              
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>  
                        </div>  

                        <h6 class="pt-6" v-if="filteredTechnicalAttrs.length > 0">Technical Attributes</h6> 
                        <div v-if="filteredTechnicalAttrs.length > 0">
                            <v-list> 
                                <v-list-item v-for="attr in filteredTechnicalAttrs" :key="attr.name">  
                                    <v-list-item-content class="pt-0">
                                        <AttributeEditField v-bind="attr" v-model="attr.value" :readonly="true" />                                          
                                    </v-list-item-content>
                                </v-list-item>                                                    
                            </v-list>  
                        </div> 

                        <h6 class="pt-6" v-if="filteredTargetingAttrs.length > 0">Targeting Attributes</h6> 
                        <div v-if="filteredTargetingAttrs.length > 0">
                            <v-list> 
                                <v-list-item v-for="attr in filteredTargetingAttrs" :key="attr.name">  
                                    <v-list-item-content class="pt-0">
                                        <AttributeEditField v-bind="attr" v-model="attr.value" :readonly="true" />                                          
                                    </v-list-item-content>
                                </v-list-item>                                                    
                            </v-list>  
                        </div> 

                        <h6 class="pt-6" v-if="filteredPositionalAttrs.length > 0">Geographical Attributes</h6> 
                        <div v-if="filteredPositionalAttrs.length > 0">
                            <v-list> 
                                <v-list-item v-for="attr in filteredPositionalAttrs" :key="attr.name">  
                                    <v-list-item-content class="pt-0">
                                        <AttributeEditField v-bind="attr" v-model="attr.value" :readonly="true" />                                          
                                    </v-list-item-content>
                                </v-list-item>                                                    
                            </v-list>  
                        </div> 

                        <h6 class="pt-6" v-if="filteredProductcategoryAttrs.length > 0">Product Categorization Attributes</h6> 
                        <div v-if="filteredProductcategoryAttrs.length > 0">
                            <v-list>  
                                <v-list-item v-for="attr in filteredProductcategoryAttrs" :key="attr.name">  
                                    <v-list-item-content class="pt-0">
                                        <AttributeEditField v-bind="attr" v-model="attr.value" :readonly="true" />
                                    </v-list-item-content>                                    
                                </v-list-item>                                                   
                            </v-list>  
                        </div>

                    </template>
                </e-info-card>
                <e-info-card
                    class="mt-6"
                    title="Target Audiences"
                    sub-title=""
                >
                    <template slot="basic-info-slot">
                        <v-simple-table>
                            <thead>
                                <tr>
                                    <th>Audience</th>
                                    <th>Rationale</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(audience, index) in targetAudiences" :key="'adp-aud-' + index">
                                    <td>{{ formatAudienceLabel(audience) }}</td>
                                    <td>{{ audience.rationale || '-' }}</td>
                                </tr>
                                <tr v-if="targetAudiences.length === 0">
                                    <td colspan="2" class="text-center text--disabled py-4">
                                        No audiences assigned.
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </template>
                </e-info-card>

                <e-info-card
                    class="mt-4"
                    title="Cluster Audiences (Preview)"
                    sub-title=""
                >
                    <template slot="basic-info-slot">
                        <v-alert v-if="clusterAudiencesPreviewLoading" type="info" border="left" dense>
                            Loading cluster audiences...
                        </v-alert>
                        <v-simple-table v-if="!clusterAudiencesPreviewLoading">
                            <thead>
                                <tr>
                                    <th>Audience</th>
                                    <th>Rationale</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(audience, index) in clusterAudiencesPreview" :key="'cluster-aud-' + index">
                                    <td>{{ formatAudienceLabel(audience) }}</td>
                                    <td>{{ audience.rationale || '-' }}</td>
                                </tr>
                                <tr v-if="clusterAudiencesPreview.length === 0">
                                    <td colspan="2" class="text-center text--disabled py-4">
                                        No audiences assigned to the selected cluster.
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </template>
                </e-info-card>
            </v-col>

            <v-col cols="10" md="8">
                <v-row>
                    <v-col class="pt-0 pb-0">
                        <base-card>
                            <v-card-title>
                                <div class="d-flex justify-space-between flex">
                                    <div>
                                        <v-menu                                
                                        ref="calcDatepicker"
                                        v-model="calculationDatepicker"
                                        :close-on-content-click="true"
                                        :close-on-click="true"
                                        
                                        transition="scale-transition"
                                        offset-y
                                        width="200px"
                                    >
                                        <template v-slot:activator="{on, attrs}">
                                            <v-text-field
                                            class="ma-4 mb-0 d-flex flex"
                                                label='Select Date'
                                                dense
                                                outlined
                                                v-model="calculationDate"                                              
                                                readonly
                                                v-bind="attrs"
                                                v-on="on"
                                                hide-details                                                    
                                                                                                
                                            ></v-text-field>                                            
                                        </template>
                                        <v-date-picker v-model="calculationDate" scrollable>                    
                                        </v-date-picker>
                                    </v-menu>                                    
                                    </div>   
                                    <v-btn class="ma-4" dark color="primary" @click="fetchData" :loading="loading">
                                            <v-icon>mdi-reload</v-icon>
                                            Reload
                                    </v-btn>                         
                                </div>
                            </v-card-title>
                        </base-card>
                    </v-col>
                </v-row>   
                <v-row>
                    <v-col cols="3" >
                        <base-card>
                            <v-list-item three-line>
                                <v-list-item-content>                                    
                                    <div class="body-2 mb-0 text--disabled">
                                        Timeline
                                    </div>
                                    <v-list-item-title
                                        class="headline mb-1 font-weight-bold"
                                        >{{ timelineData ? timelineData.length : '-' }}</v-list-item-title
                                    >
                                    <v-list-item-subtitle>
                                        <div class="d-flex flex-wrap">
                                            <span class="font-weight-bold text-info"
                                                >Slots</span
                                            >
                                        </div>
                                    </v-list-item-subtitle>
                                </v-list-item-content>                                
                            </v-list-item>
                        </base-card>
                    </v-col>
                    <v-col cols="3" >
                        <base-card>
                            <v-list-item three-line>
                                <v-list-item-content>                                    
                                    <div class="body-2 mb-0 text--disabled">
                                        Activity
                                    </div>
                                    <v-list-item-title
                                        class="headline mb-1 font-weight-bold"
                                        >{{ eventTotalCount === null ? '-' : formatInteger(eventTotalCount) }}</v-list-item-title
                                    >
                                    <v-list-item-subtitle>
                                        <div class="d-flex flex-wrap">
                                            <span class="font-weight-bold text-info"
                                                >Events</span
                                            >
                                        </div>
                                    </v-list-item-subtitle>
                                </v-list-item-content>                                
                            </v-list-item>
                        </base-card>
                    </v-col>
                    <v-col cols="3" >
                        <base-card>
                            <v-list-item three-line>
                                <v-list-item-content>                                    
                                    <div class="body-2 mb-0 text--disabled">
                                        Log Messages
                                    </div>
                                    <v-list-item-title
                                        class="headline mb-1 font-weight-bold"
                                        >{{ errorData ? errorData.length : '-' }}</v-list-item-title
                                    >
                                    <v-list-item-subtitle>
                                        <div class="d-flex flex-wrap">
                                            <span class="font-weight-bold text-info"
                                                >&nbsp;</span
                                            >
                                        </div>
                                    </v-list-item-subtitle>
                                </v-list-item-content>                                
                            </v-list-item>
                        </base-card>
                    </v-col>
                    <v-col cols="3" >
                        <base-card>
                            <v-list-item three-line>
                                <v-list-item-content>                                    
                                    <div class="body-2 mb-0 text--disabled">
                                        Current Status
                                    </div>
                                    <v-list-item-title
                                        class="headline mb-1 font-weight-bold"
                                        >{{ currentStatus }}</v-list-item-title
                                    >
                                    <v-list-item-subtitle>
                                        <div class="d-flex flex-wrap">
                                            <span class="font-weight-bold text-info"
                                                >{{ currentStatus_subtitle }}</span
                                            >
                                        </div>
                                    </v-list-item-subtitle>
                                </v-list-item-content>                                
                            </v-list-item>
                        </base-card>
                    </v-col>
                </v-row>        
                
                <v-row>
                    <v-col class="pt-0">
                        <e-info-card
                            class="pt0 pb-0"
                            title="Timeline Details"                            
                            :sub-title=" 'Last Update: ' + timelineData_lastupdatedescription + ( timelineData_lastupdate ? (' (' + timelineData_lastupdate + ')') : '' ) "
                        >
                            <template slot="basic-info-slot">    
                                <div style="width: 400px;">
                                    <apexchart
                                        type="pie"
                                        width="100%"
                                        :options="timelinePie_chartOptions"
                                        :series="timelinePie_series"
                                    />
                                </div>
                                <v-simple-table height="500px">
                                    <thead>
                                        <tr>
                                            <th>Time</th>
                                            <th>Thumbnail</th>
                                            <th>Campaign</th>
                                            <th>Rule</th>
                                            <th>Type</th>                                            
                                        </tr>
                                    </thead>
                                    <tbody class="tinytablelist">                                        
                                        <template v-for="tl in timelineData">                                            
                                            <tr  :key="tl.timestamp_plan + '_1'">                                                
                                                <td class="nobottomborder"> {{ DateToIsoString(new Date(tl.timestamp_plan)).split('T')[1].substring(0, 8) }}</td>
                                                <td rowspan="2"><img style="max-height: 28px;" :src="ExtractThumbnail(tl.srcbase)" /></td>
                                                <td class="nobottomborder">{{ tl.campaignid }}</td>
                                                <td class="nobottomborder">{{ tl.rulecode }}</td>
                                                <td class="nobottomborder">{{ tl.type }}</td>                                                                                            
                                            </tr>
                                            <tr :key="tl.timestamp_plan + '_2'" style="border-top: 0px">
                                                <td class="text-left"></td>
                                                <td></td>
                                                <td class="text-right" colspan="3">{{ decodeURI(tl.src).replace('%2F', '/').split('/').pop() }}</td>                                                
                                            </tr>
                                        </template>

                                    </tbody>
                                </v-simple-table>                                
                            </template>
                        </e-info-card>
                    </v-col>    
                </v-row>
                <v-row v-if="errorData && errorData.length">
                    <v-col class="pt-0">
                        <e-info-card                            
                            title="Log Messages (Newest to Oldest)"
                            sub-title=""
                        >
                            <template slot="basic-info-slot">     
                                <v-simple-table height="500px">
                                    <thead>
                                        <tr>                                            
                                            <th>Time</th>
                                            <th>Category</th>
                                            <th>Message</th>                                            
                                        </tr>
                                    </thead>
                                    <tbody class="tinytablelist">     
                                        <template v-for="tl in errorData">                                            
                                            <tr  :key="tl.time + '_1'">
                                            <td class="nobottomborder"> {{ tl.time }}</td>
                                            <td class="nobottomborder"> {{ tl.category }}</td>
                                            <td class="nobottomborder"> {{ tl.msg ? tl.msg.replace(',', ', ') : tl.msg }}</td>
                                            </tr>
                                            <tr :key="tl.time + '_2'" style="border-top: 0px">
                                                <td colspan="3"> <pre> {{ tl.info ? JSON.stringify(tl.info, null, 2).replace(',', ', ') : tl.info}} </pre> </td>                                            
                                            </tr>
                                        </template>                                                                           
                                    </tbody>
                                </v-simple-table>             
                            </template>
                        </e-info-card>
                    </v-col>    
                </v-row>
                <v-row v-if="eventData && eventData.length">
                    <v-col class="pt-0">
                        <e-info-card
                            class="pt0 pb-0"
                            title="Events (Newest to Oldest)"
                            sub-title=""
                        >
                            <template slot="basic-info-slot">
                                <div class="event-table-scroll" @scroll.passive="onEventTableScroll">
                                <v-simple-table>
                                    <thead>
                                        <tr>
                                            <th>Event ID</th>
                                            <th>Time</th>
                                            <th>Type</th>
                                            <th>Asset</th>
                                            <th>Campaign</th>
                                            <th>Rule</th>
                                            <th>Status</th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody class="tinytablelist">      
                                        <tr v-for="tl in eventData" :key="tl.id">   
                                            <td class="nobottomborder"> {{ tl.id }}</td>
                                            <td class="nobottomborder"> {{ DateToIsoString(new Date(tl.aud_create_date)).split('T')[1].substring(0, 8) }}</td>
                                            <td class="nobottomborder"> {{ tl.type }}</td>
                                            <td class="nobottomborder"> {{ decodeURI(tl.data.asset).replace('%2F', '/').split('/').pop() }}</td>
                                            <td class="nobottomborder"> {{ tl.campaign }}</td>
                                            <td class="nobottomborder"> {{ tl.data.rulecode }}</td>
                                            <td class="nobottomborder"> {{ tl.offline ? 'offline' : 'online' }}</td>                                            
                                        </tr>   
                                        <tr v-if="eventLoadingMore">
                                            <td colspan="7" class="text-center py-3">Loading more events...</td>
                                        </tr>
                                        <tr v-else-if="!eventHasMore && eventData.length">
                                            <td colspan="7" class="text-center py-3">All events loaded</td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                                </div>
                            </template>
                        </e-info-card>
                    </v-col>    
                </v-row>
            </v-col>
        </v-row>
        </v-form>
        <!-- <base-card class="transparent">
            
        </base-card> -->
        <v-snackbar
            v-model="snackbar"
            :timeout="4000"
            bottom
            tile
            :color="snackbarColor + ' -accent-2'"            
            >
            {{ snackbarMessage }}
        </v-snackbar>
    </div>
</template>
<script>
import avatarGroupCard from '@/components/card/AvatarGroupCard';
import EInfoCard from '@/components/card/BasicInfoCard';
import {api} from "src/api/index";
import { fieldNotEmpty, fieldMinLength } from "src/core/vuetify-validators.js";
import AttributeEditField from '@/components/core/AttributeEditField';
import moment from "moment";

//TODO: Permissions
export default {
    metaInfo: {
        // title will be injected into parent titleTemplate
        title: 'Adpoint Details'
    },
    components: {
        avatarGroupCard,
        EInfoCard,
        AttributeEditField
    },
    data() {
        return {
            calculationDatepicker: null,
            calculationDate: null,
            timelineData: null,
            timelineData_lastupdate: null,
            
            eventData: null,
            eventTotalCount: null,
            eventPageSize: 200,
            eventCurrentPage: 0,
            eventHasMore: false,
            eventLoadingMore: false,
            errorData: null,   
            currentStatus: null, 
            currentStatus_subtitle: "",   
            timelinePie_series: null, //this.convertToTimechartData_series([]),
            timelinePie_chartOptions: null, //this.convertToTimechartData_chartOptions([]),
            eventsPie_series: this.convertToTimechartData([]).series,
            eventsPie_chartOptions: this.convertToTimechartData([]).chartOptions,
            errorsPie_series: this.convertToTimechartData([]).series,
            errorsPie_chartOptions: this.convertToTimechartData([]).chartOptions,


            // //timeline grid - start
            // tlgrid_selected: [],
            // tlgrid_headers: [],
            // tlgrid_pagingOptions: null,
            // tlgrid_totalItemCount: null,
            // tlgrid_gridData: null,
            // //timeline grid - end


            //primary data
            adpointid: '',
            description: '',
            networkId: '',
            clusterId: '',
            deviceId: '',
            brandId: '',
            location: '',
            locationAndOperInfo: null,
            environment: '',
            debugmode: false,
            status: '',
            nominalCapacity: '',
            impression_factor: 1,
            multiview: false,
            dynamicAttrs: {},
            targetAudiences: [],
            clusterAudiencesPreview: [],
            clusterAudiencesPreviewLoading: false,

            fieldSchemeHasChanged: false,


            type: '',
            crud_code: '',
            disabled: false,
            //ui mechanics      
            createMode: false,                  
            invitationFormValid: true,
            editFormValid: true,            
            //error
            loading: false,
            snackbar: false,
            snackbarColor: 'green',
            snackbarMessage: '',
            error: '',
            //reference data    
            networkOptions: [],
            clusterOptions: [],
            deviceTypeOptions: [],
            brandOptions: [],
            environmentOptions: [{value: 'ADDREALITY', text: 'DisplayForce'},{value: 'PRODME', text: 'Product.me'},{value: 'OTHER', text: 'Other'}],
            locationOptions: [],
            allLocations: [],
            requiredRules: [
                fieldNotEmpty                
            ],
            codeRules: [
                fieldNotEmpty,            
                (v) => fieldMinLength(v, 2)  
            ],
            treeitems: [
        {
          id: 5,
          name: 'Country :',
          children: [
            {
              id: 6,
              name: 'Area :',
              children: [
                {
                  id: 7,
                  name: 'Store :',
                  children: [
                    { id: 8, name: 'Floor :' },
                    { id: 9, name: 'Section :' },
                  ],
                },
              ],
            }           
          ],
        },       
      ]
        }
    },
    computed: {
        filteredGenericAttrs() {
            return (this.dynamicAttrs.generic || []).filter(attr => this.hasValue(attr.value));
        },
        filteredTechnicalAttrs() {
            return (this.dynamicAttrs.technical || []).filter(attr => this.hasValue(attr.value));
        },
        filteredTargetingAttrs() {
            return (this.dynamicAttrs.targeting || []).filter(attr => this.hasValue(attr.value));
        },
        filteredPositionalAttrs() {
            return (this.dynamicAttrs.positional || []).filter(attr => this.hasValue(attr.value));
        },
        filteredProductcategoryAttrs() {
            return (this.dynamicAttrs.productcategory || []).filter(attr => this.hasValue(attr.value));
        },
        displayLocationExtraInfo() {
            const loc = this.allLocations.find(l => l.code === this.location);
            if(!loc || !loc.extra_info) {
                return 'No Extra Info';
            }
            const { nearby_places_data, ...rest } = loc.extra_info;
            return JSON.stringify(rest, null, 6);
        },
        manualstatus: {
            get() {
                return this.status === 'Online' ? 'Enabled' : 'Disabled';
            },
            set(newValue) {
                if(newValue === 'Enabled') {
                    this.status = 'Online';
                }
                if(newValue === 'Disabled') {
                    this.status = 'Offline';
                }
            }
        } ,
        timelineData_lastupdatedescription() {
            if(this.timelineData_lastupdate) {
                return moment.utc(this.timelineData_lastupdate).fromNow();
            }            
            else {
                return "-";
            }
        }
    },
    watch: {
        calculationDate: {
            async handler(oldVal, newVal) {
                await this.fetchData();                
            },
            immediate: false
        }        
    },
    async created() {
        if(this.$route.params.code) {
            this.crud_code = this.$route.params.code;       
            this.createMode = false;     
        }
        else {            
            this.createMode = true;
        }

        let rsp = {};        
        if(!this.createMode) {
            rsp = await api.adpoint.getInitEditData(this.crud_code);
            
        }
        else {
            rsp = await api.adpoint.getInitEditData();
        }
        this.initEditForm(rsp);        
        this.calculationDate = (new Date()).toISOString().substring(0,10);         
    },
    async mounted() {     
        
        // if(!this.createMode) {
        //     const rspB = await api.network.getOne(this.crud_code);
        //     if(rspB && rspB.data) {
        //         this.code = rspB.data.code;
        //         this.title = rspB.data.title;
        //         this.description = rspB.data.description;
        //         this.type = rspB.data.type;            
        //     }
        //     //this.editFormValid = true;  
        // }      
    },
    methods: {
        initEditForm(rsp) {
            this.networkOptions = rsp.data.init.networkOptions;
            this.clusterOptions = rsp.data.init.clusterOptions;
            this.deviceTypeOptions = rsp.data.init.deviceTypeOptions;
            this.brandOptions = rsp.data.init.brandOptions;  
            this.locationOptions = rsp.data.init.locationOptions
            this.allLocations = rsp.data.init.allLocations;
            this.reloadFormData(rsp.data.edit);
        },
        reloadFormData(editData) {
            const safeEditData = editData || {};
            this.adpointid = safeEditData.adpointid;
            this.description = safeEditData.description;
            this.networkId = safeEditData.networkId;
            this.clusterId = safeEditData.clusterId;
            this.deviceId = safeEditData.deviceId;
            this.brandId = safeEditData.brandId;
            this.location = safeEditData.location;
            this.status = safeEditData.status || 'Online';
            this.environment = safeEditData.environment;
            this.debugmode = safeEditData.debugmode;
            this.nominalCapacity = safeEditData.nominalCapacity || 2880;
            this.impression_factor = safeEditData.impression_factor || 1;        
            this.multiview = !!editData.multiview || false;    
            this.dynamicAttrs = this._convertAttrsToArray(safeEditData.attributes || {});

            const audiences = Array.isArray(safeEditData.audiences) ? safeEditData.audiences : [];
            this.targetAudiences = audiences.map(a => ({
                audience_code: a.audience_code || (a.audience ? a.audience.code : null),
                audience: a.audience || null,
                rationale: a.rationale || ''
            }));
            this.fetchClusterAudiences(this.clusterId);

            //this.$refs.editForm.resetValidation();
            this.fieldSchemeHasChanged = false;
        },
        async fetchClusterAudiences(clusterId) {
            if(!clusterId) {
                this.clusterAudiencesPreview = [];
                this.clusterAudiencesPreviewLoading = false;
                return;
            }
            this.clusterAudiencesPreviewLoading = true;
            try {
                const rsp = await api.cluster.getOne(clusterId);
                this.clusterAudiencesPreview = (rsp.data?.audiences || []).map(a => ({
                    audience_code: a.audience_code || (a.audience ? a.audience.code : null),
                    audience: a.audience || null,
                    rationale: a.rationale || ''
                }));
            } catch (error) {
                this.clusterAudiencesPreview = [];
            } finally {
                this.clusterAudiencesPreviewLoading = false;
            }
        },
        formatAudienceLabel(audienceEntry) {
            if(!audienceEntry) {
                return '-';
            }
            const aud = audienceEntry.audience;
            return (aud && (aud.condensed_name || aud.code)) || audienceEntry.audience_code || '-';
        },
        formatInteger(value) {
            if(value === null || value === undefined || value === '') {
                return '-';
            }
            return new Intl.NumberFormat().format(value);
        },
        convertToTimechartData_series(srcSeries) {
            const rslt = [...srcSeries.map(i=>i.value)];
            return rslt;
        },
        convertToTimechartData_chartOptions(srcSeries) {
            const labels = [...srcSeries.map(i=>i.label)];
            const rslt = {
                legend: {
                    position: 'bottom',
                },
                labels: labels,
                theme: {
                    monochrome: {
                    enabled: true,
                    },
                },
                title: {
                    text: '',
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                    chart: {
                        width: 200,
                    },
                    legend: {
                        position: 'bottom',
                    },
                    },
                }],
            };
            return rslt;
        },
        convertToTimechartData(srcSeries) {
            // srcSeries = [
            //     {label: "MondayTESTESTESTETESTESTESTESSαβγ", value: 32},
            //     {label: "TuesdayTESTESTESTESTESTESTESTES", value: 42},
            //     {label: "ModndayTESTESTESTESTESTESTESTES", value: 32},
            //     {label: "TuegsdayTESTESTESTESTESTESTESTES", value: 42},
            //     {label: "MonsdayTESTESTESTESTESTESTESTES", value: 32},
            //     {label: "ThuesdayTESTESTESTESTESTESTESTES", value: 42},
            //     {label: "MonsdayTESTESTESTESTESTESTESTES", value: 32},
            //     {label: "TudesdayTESTESTESTESTESTESTESTES", value: 42},
            //     {label: "M5ondayTESTESTESTESTESTESTESTES", value: 32},
            //     {label: "TuehsdayTESTESTESTESTESTESTESTES", value: 42},
            // ];
            // srcSeries = [
            // {label: 'M231-ASUS-ZENBOOK', value: 3},
            // {label: 'M215-GENERALI-CAMPAIGN', value: 2},
            // {label: 'Kotsovolos Generic Χαλί TVs', value: 9},
            // {label: 'Vodafone TV HBO', value: 1},
            // {label: 'Alpha Bonus', value: 1},
            // {label: 'Anytime Ασφάλιση', value: 1},
            // ]

            srcSeries = [...srcSeries.map(i=> { return {label: i.label, value: i.value} })];
            return {
                series: [...srcSeries.map(i=>i.value)],
                chartOptions: {
                legend: {
                    position: 'bottom',
                },
                labels: [...srcSeries.map(i=>i.label)],
                theme: {
                    monochrome: {
                    enabled: true,
                    },
                },
                title: {
                    text: '',
                },
                responsive: [{
                    breakpoint: 480,
                    options: {
                    chart: {
                        width: 200,
                    },
                    legend: {
                        position: 'bottom',
                    },
                    },
                }],
                },
            }
        },
        hasValue(val) {
            if(val === null || val === undefined || val === '') return false;
            if(Array.isArray(val) && val.length === 0) return false;
            return true;
        },
        onSchemeChanged() {
            this.fieldSchemeHasChanged = true;
        },
        buildEventQueryString(page = 1, limit = this.eventPageSize) {
            let eventQstr = "?currentPage=" + encodeURIComponent(page);
            eventQstr += "&limit=" + encodeURIComponent(limit);
            eventQstr += "&adpointid=" + encodeURIComponent(this.adpointid);
            eventQstr += "&date=" + encodeURIComponent(this.calculationDate);
            return eventQstr;
        },
        resetEventListState() {
            this.eventData = [];
            this.eventTotalCount = null;
            this.eventCurrentPage = 0;
            this.eventHasMore = false;
            this.eventLoadingMore = false;
        },
        async fetchEventCount() {
            const countRsp = await api.event.getCountAdpointStats(this.buildEventQueryString(1, 1));
            this.eventTotalCount = countRsp && countRsp.data ? countRsp.data.total || 0 : 0;
            this.eventHasMore = this.eventTotalCount > 0;
        },
        async loadNextEventPage() {
            if(this.eventLoadingMore || !this.eventHasMore || !this.adpointid) {
                return;
            }

            this.eventLoadingMore = true;
            try {
                const nextPage = this.eventCurrentPage + 1;
                const rsp = await api.event.getListAdpointStats(this.buildEventQueryString(nextPage, this.eventPageSize));
                const rows = rsp && rsp.data && Array.isArray(rsp.data.data) ? rsp.data.data : [];
                this.eventData = [...(this.eventData || []), ...rows];
                this.eventCurrentPage = nextPage;
                this.eventHasMore = this.eventData.length < this.eventTotalCount;
            }
            finally {
                this.eventLoadingMore = false;
            }
        },
        onEventTableScroll(event) {
            const target = event && event.target ? event.target : null;
            if(!target || this.eventLoadingMore || !this.eventHasMore) {
                return;
            }

            const remainingScroll = target.scrollHeight - target.scrollTop - target.clientHeight;
            if(remainingScroll <= 48) {
                this.loadNextEventPage();
            }
        },               
        _convertAttrsToArray(src) {
            const rslt = Object.values(src).reduce((rslt, arrayItem) => {
                if(!arrayItem.hierarchy) {
                    if(!rslt['generic']) rslt['generic'] = [];
                    rslt['generic'].push(arrayItem);
                }
                else {
                    if(!rslt[arrayItem.hierarchy]) rslt[arrayItem.hierarchy] = [];
                    rslt[arrayItem.hierarchy].push(arrayItem);
                }
                return rslt;
            }, {});
            let orderedRslt = {};
            for(const group in rslt){
                orderedRslt[group] = rslt[group].sort((a,b)=>{
                    if(a.name < b.name) return -1;
                    if(a.name > b.name) return 1;
                    return 0;
                })
            }
            return orderedRslt;
        },
        async fetchData() {                   
            let seedDate = this.calculationDate;
            if(this.adpointid && (this.adpointid !== '')) {                
                try {
                    this.loading = true;
                    //GET ADPOINT AVAILABILITY STATUS 


                    let availStatusRsp = await api.adpoint.getAvailabilityStatus(this.adpointid);
                    if(availStatusRsp && availStatusRsp.data) {
                        if(!availStatusRsp.data.targeted) {
                            this.currentStatus = "Not Targeted";
                            this.currentStatus_subtitle = "";
                        }
                        else {
                            if(!availStatusRsp.data.unresponsive) {
                                this.currentStatus = "Online";
                                this.currentStatus_subtitle = "Last event: " + availStatusRsp.data.minutespassed + " min(s) ago";
                            }
                            else {
                                this.currentStatus = "Unresponsive";
                                if(availStatusRsp.data.minutespassed == -1) {
                                    this.currentStatus_subtitle = "No events today";
                                }
                                else {
                                    this.currentStatus_subtitle = "Last event: " + availStatusRsp.data.minutespassed + " min(s) ago";
                                }                                
                            }
                        }                        
                    }


                    //GET TIMELINE DTA
                    let timelineRsp = await api.adpoint.getTimelineStats(this.adpointid, seedDate);
                    if(timelineRsp && timelineRsp.data) {                        
                        this.timelineData_lastupdate = timelineRsp.data.aud_update_date;
                    }
                    else {
                        this.timelineData_lastupdate = null;
                    }
                    if(timelineRsp && timelineRsp.data && timelineRsp.data.main) {
                        this.timelineData = timelineRsp.data.main;                        
                    }                    
                    else {
                        this.timelineData = [];                        
                    }
                    //let timelinePie = this.convertToTimechartData(timelineRsp.data.chart);
                    this.timelinePie_series = this.convertToTimechartData_series(timelineRsp.data.chart);
                    this.timelinePie_chartOptions = this.convertToTimechartData_chartOptions(timelineRsp.data.chart);
                    //GET EVENT DATA
                    this.resetEventListState();
                    await this.fetchEventCount();
                    await this.loadNextEventPage();
                    //GET EVENT ERRORS
                    const errorRsp = await api.event.getErrorList(this.buildEventQueryString(1, 10000)); 
                    this.errorData = errorRsp.data;    
                    // alert(JSON.stringify(this.eventData));
                } catch (error) {
                    
                }
                finally {
                    this.loading = false;
                }

                


            }
        },
        _convertArrayToAttrs(src) {
            let rslt = {};
            for(const srcProp in src) {
                for(const attr of src[srcProp]) {
                    rslt[attr.name] = attr;
                }
            }            
            return rslt;
        },    
        DateToIsoString(date) {
            var tzo = -date.getTimezoneOffset(),
                dif = tzo >= 0 ? '+' : '-',
                pad = function(num) {
                    return (num < 10 ? '0' : '') + num;
                };

            return date.getFullYear() +
                '-' + pad(date.getMonth() + 1) +
                '-' + pad(date.getDate()) +
                'T' + pad(date.getHours()) +
                ':' + pad(date.getMinutes()) +
                ':' + pad(date.getSeconds()) +
                dif + pad(Math.floor(Math.abs(tzo) / 60)) +
                ':' + pad(Math.abs(tzo) % 60);
        }  ,
        ExtractThumbnail(src) {
            let parts = [...src.split('.')];
            let filetype = parts[parts.length-1];
            if(filetype.toLowerCase()!='png' && filetype.toLowerCase()!='jpg') {
                filetype = 'png';
            }
            parts.splice(-1);            
            parts[parts.length-1] = parts[parts.length-1] + '_thumb.' + filetype;
            return parts.join('.');
        }      
    }
}
</script>
<style lang="scss">
.ul-widget-profile-img {
    position: relative;
}
.ul-widget-profile-img:after {
    // content: "";
    // position: absolute;
    // top: 44px;
    // left: 50%;
    // width: 1px;
    // height: calc(100% - 30px);
    // background: #B3C0CE;
    content: '';
    position: absolute;
    top: 44px;
    left: 50%;
    width: 1px;
    height: calc(100% - 30px);
    background: #b3c0ce;
}
.tinytablelist td {
    font-size: 12px !important;
    height: 16px !important;
}
.tinytablelist td.nobottomborder {
    border-bottom-style: none !important;
}
.event-table-scroll {
    max-height: 500px;
    overflow-y: auto;
}
.location-extra-pre {
    white-space: pre-wrap;
    word-break: break-word;
}
</style>
